import React, { Component, Fragment } from "react";
import { FieldGroup, FieldControl, FormBuilder } from "react-reactive-form";
import { readableResponseMessage } from "ux-helpers";
import { Auth, API, Storage } from "aws-amplify";
import { scroller } from "ux-helpers";
// import Modal from "react-modal";
// import PadiPreviewModal from "./previewModals/PadiPreviewModal";
import PropTypes from "proptypes";

class PadiScuba extends Component {
  state = {
    destination: this.props.destination,
    pADIMedicalFormPage1: this.props.pADIMedicalFormPage1
      ? this.props.pADIMedicalFormPage1
      : {},
    pADIMedicalFormPage2: this.props.pADIMedicalFormPage2
      ? this.props.pADIMedicalFormPage2
      : {},
    scubaLiabilityRelease: this.props.scubaLiabilityRelease
      ? this.props.scubaLiabilityRelease
      : {},
    currentDocumentName: null,
    scubaBookingFormFastManta: this.props.scubaBookingFormFastManta,
    scubaCertificationLevel: this.props.scubaCertificationLevel,
    scubaCertificationLevelNotes: this.props.scubaCertificationLevelNotes,
    scubaPadiELearningCompleted: this.props.scubaPadiELearningCompleted,
    scubaPadiMedicalClearanceRequired: this.props.scubaPadiMedicalClearanceRequired,
    scubaPadiMedicalClearanceSent: this.props.scubaPadiMedicalClearanceSent,
    scubaPadiMedicalQuestionnaireCompleted: this.props.scubaPadiMedicalQuestionnaireCompleted,
    openModal: this.props.openModal,
    closeModal: this.props.closeModal
  };

  scubaStatusForm = FormBuilder.group({
    scubaBookingFormFastManta: this.state.scubaBookingFormFastManta,
    scubaCertificationLevel: this.state.scubaCertificationLevel,
    scubaCertificationLevelNotes: this.state.scubaCertificationLevelNotes,
    scubaPadiELearningCompleted: this.state.scubaPadiELearningCompleted,
    scubaPadiMedicalClearanceRequired: this.state.scubaPadiMedicalClearanceRequired,
    scubaPadiMedicalClearanceSent: this.state.scubaPadiMedicalClearanceSent,
    scubaPadiMedicalQuestionnaireCompleted: this.state.scubaPadiMedicalQuestionnaireCompleted
  });

  componentDidMount() {
    Auth.currentSession().then(user => {
      this.setState({
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken
        }
      });
    });

    const medicalClearanceControl = this.scubaStatusForm.get("scubaPadiMedicalClearanceRequired");

    medicalClearanceControl.onValueChanges.subscribe(value => {
      this.setState({
        scubaPadiMedicalClearanceRequired: value
      });
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ loadingBtn: true });
    this.scubaStatusForm.handleSubmit();

    Auth.currentSession().then(user => {
      const options = {
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
          "Content-Type": "application/json"
        },
        body: this.scubaStatusForm.value
      };
      API.post(
        "give-api",
        `/documents/${this.props.tripId}/scuba/`,
        options
      )
      .then(response => {
        this.setState({
          loadingBtn: false,
          message: response.Message
        });
        setTimeout(() => {
          this.setState({ message: "" });
        }, 3000);
        this.scubaStatusForm.handleSubmit();
        this.props.deactiveActiveAccordion("padiScuba-widget");
        scroller("required-documents");
      })
      .catch(error => {
        this.setState({
          loadingBtn: false,
          message: readableResponseMessage(error)
        });
        this.scubaStatusForm.handleSubmit();
      });
    });
  }

  onImageSelect = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      // TODO: Remove comment
      // this.state.currentDocumentName = e.target.name;
      reader.addEventListener("load", () => {
        this.uploadImage(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
      this.padiScubaForm.controls.travelDocument.setValue(e.target.files[0]);
      this.uploadDocument(e.target.files[0]);
      this.setState({
        currentDocumentName: e.target.name,
        travelDocumentFileName: e.target.files[0].name
      });
    }
  };

  uploadDocument = document => {
    const fileName = document.name;
    const fileType = document.type;
    Storage.put(fileName, document, {
      level: 'protected',
      contentType: fileType
    })
    .catch(error => {
      this.setState({
        message: "Whoops! Looks like we had a problem uploading your file."
      });
    });
  }

  returnFileNameAndType = (travelDocumentURL) => {
    const url = travelDocumentURL;
    const fileName = url.substring(url.lastIndexOf('/') + 1);
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    return {
      key: url,
      type: extension
    }
  }

  // openModal = (modalName, travelDocumentURL) => {
  //   let fileAttributes = this.returnFileNameAndType(travelDocumentURL);
  //   Storage.get(fileAttributes.key, { level: 'protected' })
  //   .then(result => {
  //     if (fileAttributes.type === 'pdf' || fileAttributes.type === 'doc' || fileAttributes.type === 'docx') {
  //       window.open(result);
  //     } else {
  //       this.setState({
  //         previewUrl: result,
  //         activeModal: modalName
  //       });
  //     }
  //   })
  //   .catch(() => {});
  // };

  // closeModal = () => {
  //   this.setState({
  //     activeModal: null
  //   });
  // };

  uploadImage = encodedImage => {
    Auth.currentSession().then(user => {
      const options = {
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
          "Content-Type": "application/json"
        },
        body: {
          userId: this.props.userId,
          userName: user.idToken.payload.nickname,
          travelDocument: encodedImage,
          travelDocumentName: this.state.currentDocumentName,
          fileName: this.state.travelDocumentFileName
        }
      };

      API.post("give-api", `/documents/${this.props.tripId}/scuba`, options)
        .then(response => {
          this.setState({
            [this.state.currentDocumentName]: {
              travelDocumentURL: response.Data.travelDocumentUrl
                ? response.Data.travelDocumentUrl
                : this.state.$name.travelDocumentURL
            }
          });
          this.props.setDocumentsAccordionState(this.state.currentDocumentName);
          this.setState({
            message: response.Message
          });
          this.padiScubaForm.handleSubmit();
        })
        .catch(error => {
          this.setState({
            message: readableResponseMessage(error)
          });
          this.padiScubaForm.handleSubmit();
        });
    });
  };

  setHeight = () => {
    window.setTimeout(() => {
      const obj = document.getElementById("padiScuba-widget");
      const objContent = document.getElementById("padiScuba-widget-content");
      const containerHeight = objContent.offsetHeight;
      obj.style.height = `${containerHeight + 100}px`;
    }, 200);
  };

  padiScubaForm = FormBuilder.group({
    travelDocument: [""]
  });

  render() {
    return (
      <div>
        {this.state.message ? (
          <p
            className={`center ${
              this.state.message === "Successfully Updated" ||
              this.state.message === "Successfully Created"
                ? "success"
                : "error"
            }`}
          >
            {this.state.message}
          </p>
        ) : (
          ""
        )}
        <p>
          Please input your current level of scuba certification today. If you are certified, remember to bring proof of your certification card for the dive shop.
        </p>
        <FieldGroup
          control={this.scubaStatusForm}
          render={({ value, submitted }) => (
            <form
              name="PADI Scuba"
              id="padi-scuba-form"
              onSubmit={e => this.handleSubmit(e, value)}
              autoComplete="off"
            >
              <FieldControl
                name="scubaCertificationLevel"
                render={({ handler, pristine }) => (
                  <div className="inputContainer">
                    <select
                      className="custom-arrow form-control"
                      {...handler()}
                    >
                      <option disabled value=""></option>
                      <option value="Not Open Water Certified">Not Open Water Certified</option>
                      <option value="Open Water Certified">Open Water Certified</option>
                      <option value="Advanced Certified">Advanced Certified</option>
                      <option value="Other">Other</option>
                    </select>
                    <label
                      htmlFor="scubaCertificationLevel"
                      className={`label ${
                        pristine ? "" : "notEmpty"
                      }`}
                    >
                      Scuba Certification Level{" "}
                    </label>
                  </div>
                )}
              />
              <FieldControl
                name="scubaCertificationLevelNotes"
                render={({ handler, touched, hasError, pristine }) => (
                  <div className="inputContainer">
                    <textarea
                      className="form-control"
                      type="text"
                      {...handler()}
                    />
                    <label
                      htmlFor="scubaCertificationLevelNotes"
                      className={`label ${pristine && this.state.scubaCertificationLevelNotes === "" ? "" : "notEmpty"}`}
                    >
                      Scuba Certification Level Notes
                      <span className="error">
                        {(touched || submitted) &&
                          hasError("required") &&
                          " - Required"}
                      </span>
                    </label>
                  </div>
                )}
              />
            {(this.state.destination.indexOf('Thailand') >= 0) &&
              <Fragment>
                <p>
                  <b>Partner requirements:</b> You are required to complete our partner's requirements below to be eligible to scuba dive. Note these requirements may not coincide with your Document Deadlines above. You will receive an email with details to complete the below requirements:
                </p>
                <p>
                <b>Scuba Booking Form:</b> Please refer to GIVE's email to correctly fill out the required booking form:{' '}
                  <a href="https://go.givevolunteers.org/thailandscubaform" target="_blank" rel="noopener noreferrer">Scuba Booking Form</a>
                </p>
                <FieldControl
                  name="scubaBookingFormFastManta"
                  render={({ handler }) => (
                    <div className="checkboxContainer">
                      <label htmlFor="scubaBookingFormFastManta" className="small-text">
                        <span className="muted">&#10148;</span> Check this box to confirm that you have completed the Scuba Booking Form (link above) <button className="inline btn-plain-text small-text" onClick={() => this.state.openModal()}>(view instructions)</button>:
                      </label>
                      <input
                        type="checkbox"
                        {...handler("checkbox")}
                      />
                    </div>
                  )}
                />
              </Fragment>
            }
            <p>
              <b>PADI Requirements:</b> You must complete your PADI eLearning Training and complete the PADI Medical Questionnaire. Within 30 days of uploading your booked flight itinerary and/or confirmation in the flight section, you will receive an email from PADI with onboarding instructions and requirements.
            </p>
            <FieldControl
              name="scubaPadiELearningCompleted"
              render={({ handler }) => (
                <div className="checkboxContainer">
                  <label htmlFor="scubaPadiELearningCompleted" className="small-text">
                    <span className="muted">&#10148;</span> Check this box to confirm that you have completed your PADI Elearning training: 
                  </label>
                  <input
                    type="checkbox"
                    {...handler("checkbox")}
                  />
                </div>
              )}
            />
            <br/>
            <FieldControl
              name="scubaPadiMedicalQuestionnaireCompleted"
              render={({ handler }) => (
                <div className="checkboxContainer">
                  <label htmlFor="scubaPadiMedicalQuestionnaireCompleted" className="small-text">
                    <span className="muted">&#10148;</span> Check this box to confirm that you completed your PADI Elearning Medical Questionnaire:
                  </label>
                  <input
                    type="checkbox"
                    {...handler("checkbox")}
                  />
                </div>
              )}
            />
            <br/>
            <FieldControl
              name="scubaPadiMedicalClearanceRequired"
              render={({ handler, touched, hasError }) => (
                <div>
                  <label htmlFor="scubaPadiMedicalClearanceRequired" className="small-text">
                    <b>Do you require a physician's clearance?</b>
                  </label>
                  <span className="error">
                    {(touched || submitted) &&
                      hasError("required") &&
                      " - Required"}
                  </span>
                  <input
                    className="radio-button"
                    name="physician"
                    id="physician-yes"
                    type="radio"
                    onClick={() => this.setHeight()}
                    {...handler("radio", "Yes")}
                  />
                  <label htmlFor="physician-yes">Yes</label>
                  <input
                    className="radio-button"
                    name="physician"
                    id="physician-no"
                    type="radio"
                    onClick={() => this.setHeight()}
                    {...handler("radio", "No")}
                  />
                  <label htmlFor="physician-no">No</label>
                </div>
              )}
            />
            <br/>
            {
              this.state.scubaPadiMedicalClearanceRequired === "Yes" &&
              <Fragment>
                <FieldControl
                  name="scubaPadiMedicalClearanceSent"
                  render={({ handler }) => (
                    <div className="checkboxContainer">
                      <label htmlFor="scubaPadiMedicalClearanceSent" className="small-text">
                        <span className="muted">&#10148;</span> Check this box to confirm you have emailed the completed physician's clearance form to GIVE's partner dive company and cc GIVE.
                      </label>
                      <input
                        type="checkbox"
                        {...handler("checkbox")}
                      />
                    </div>
                  )}
                />
                {(this.state.destination.indexOf('Thailand') >= 0) &&
                  <p>
                    <i>If a physician's clearance is required as indicated by your answers to the PADI Medical Questionnaire, then you must email the completed form signed by your physician to GIVE's partner dive company, Fast Manta, at <a href="info@fastmanta.com?subject=Scuba%20Clearance&cc=info@givevolunteers.org" target="_blank" rel="noopener noreferrer">info@fastmanta.com</a> and cc info@givevolunteers.org. It is essential you carefully follow these requirements or you will not be eligible to dive.</i>
                  </p>
                }
                {(this.state.destination.indexOf('Hawaii') >= 0) &&
                  <p>
                    <i>If a physician's clearance is required as indicated by your answers to the PADI Medical Questionnaire, then you must email the completed form signed by your physician to GIVE's partner dive company, Kohala Divers, at <a href="godiving@kohaladivers.com?subject=Scuba%20Clearance&cc=info@givevolunteers.org" target="_blank" rel="noopener noreferrer">godiving@kohaladivers.com</a> and cc info@givevolunteers.org. It is essential you carefully follow these requirements or you will not be eligible to dive.</i>
                  </p>
                }
              </Fragment>
            }
            </form>
          )}
        />
        {(this.state.destination.indexOf('Thailand') >= 0) &&
          <p>
            If you have any questions about diving requirements, email <a href="info@fastmanta.com?subject=Scuba%20Diving%20Requirements&cc=info@givevolunteers.org" target="_blank" rel="noopener noreferrer">info@fastmanta.com</a> and cc info@givevolunteers.org
          </p>
        }
        {(this.state.destination.indexOf('Hawaii') >= 0) &&
          <p>
            If you have any questions about diving requirements, email  <a href="godiving@kohaladivers.com?subject=Scuba%20Diving%20Requirements&cc=info@givevolunteers.org" target="_blank" rel="noopener noreferrer">godiving@kohaladivers.com</a> and cc info@givevolunteers.org
          </p>
        }
        <p>
          All divers are required to complete the standard PADI Medical Form as
          part of course registration.
        </p>

        <br/>
        <button
          onClick={e => this.handleSubmit(e)}
          className={`${this.state.loadingBtn ? "btn-text-hide" : ""}`}
          type="submit"
          disabled={this.state.loadingBtn}
        >
          Update
          <span className={`${this.state.loadingBtn ? "loader" : ""}`} />
        </button>

        {this.state.pADIMedicalFormPage1 &&
        this.state.pADIMedicalFormPage1.travelDocumentURL ? (
          <div>
            <p>
              <strong>Page 1 Uploaded! {" "}</strong>
              <button
                className="inline btn-plain-text"
                onClick={() => this.openModal("padiPreviewModal", this.state.pADIMedicalFormPage1.travelDocumentURL)}
              >
                &#8226; Preview
              </button>
              <span className="upload-btn-wrapper">
                &#8226; Update
                <input
                  id="travelDocument"
                  name="pADIMedicalFormPage1"
                  type="file"
                  onChange={e => this.onImageSelect(e)}
                />
              </span>
            </p>
            <br/>
          </div>
        ) : (
          ""
        )}
        {this.state.pADIMedicalFormPage2 &&
        this.state.pADIMedicalFormPage2.travelDocumentURL ? (
          <div>
            <p>
              <strong>Page 2 Uploaded!{" "}</strong>
              <button
                className="inline btn-plain-text"
                onClick={() => this.openModal("padiPreviewModal", this.state.pADIMedicalFormPage2.travelDocumentURL)}
              >
                &#8226; Preview
              </button>
              <span className="upload-btn-wrapper">
                &#8226; Update
                <input
                  id="travelDocument"
                  name="pADIMedicalFormPage2"
                  type="file"
                  onChange={e => this.onImageSelect(e)}
                />
              </span>
            </p>
            <br/>
          </div>
        ) : (
          ""
        )}
        {this.state.scubaLiabilityRelease &&
        this.state.scubaLiabilityRelease.travelDocumentURL ? (
          <div>
            <strong>Liability Release Uploaded!{" "}</strong>
            <button
                className="inline btn-plain-text"
                onClick={() => this.openModal("padiPreviewModal", this.state.scubaLiabilityRelease.travelDocumentURL)}
              >
                &#8226; Preview
              </button>
            <p className="upload-btn-wrapper">
              &#8226; Update
              <input
                id="travelDocument"
                name="scubaLiabilityRelease"
                type="file"
                onChange={e => this.onImageSelect(e)}
              />
            </p>
          </div>
        ) : (
          ""
        )}

        {/* {dynamicUploadText} */}

        {/* <FieldGroup
          control={this.padiScubaForm}
          render={({ value, submitted }) => (
            <form
              onSubmit={e => this.handleSubmit(e, value)}
              autoComplete="off"
            >
              {this.state.pADIMedicalFormPage1 &&
              !this.state.pADIMedicalFormPage1.travelDocumentURL ? (
                <div>
                  <FieldControl
                    name="travelDocument"
                    render={({ touched, hasError }) => (
                      <div className="inputContainer">
                        <input
                          id="travelDocument"
                          name="pADIMedicalFormPage1"
                          className="form-control"
                          type="file"
                          onChange={e => this.onImageSelect(e)}
                        />
                        <label
                          htmlFor="travelDocument"
                          className="label notEmpty"
                        >
                          Page 1 Upload
                          <span className="error">
                            {(touched || submitted) &&
                              hasError("required") &&
                              " - Required"}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                </div>
              ) : (
                ""
              )}

              {this.state.pADIMedicalFormPage2 &&
              !this.state.pADIMedicalFormPage2.travelDocumentURL ? (
                <div>
                  <FieldControl
                    name="travelDocument"
                    render={({ touched, hasError }) => (
                      <div className="inputContainer">
                        <input
                          id="travelDocument"
                          name="pADIMedicalFormPage2"
                          className="form-control"
                          type="file"
                          onChange={e => this.onImageSelect(e)}
                        />
                        <label
                          htmlFor="travelDocument"
                          className="label notEmpty"
                        >
                          Page 2 Upload
                          <span className="error">
                            {(touched || submitted) &&
                              hasError("required") &&
                              " - Required"}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                </div>
              ) : (
                ""
              )}

              {this.state.scubaLiabilityRelease &&
              !this.state.scubaLiabilityRelease.travelDocumentURL ? (
                <div>
                  <FieldControl
                    name="travelDocument"
                    render={({ touched, hasError }) => (
                      <div className="inputContainer">
                        <input
                          id="travelDocument"
                          name="scubaLiabilityRelease"
                          className="form-control"
                          type="file"
                          onChange={e => this.onImageSelect(e)}
                        />
                        <label
                          htmlFor="travelDocument"
                          className="label notEmpty"
                        >
                          Liability Release
                          <span className="error">
                            {(touched || submitted) &&
                              hasError("required") &&
                              " - Required"}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                </div>
              ) : (
                ""
              )}
            </form>
          )}
        /> */}
        {/* <br />
        <Modal
          isOpen={this.state.activeModal === "padiPreviewModal"}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <PadiPreviewModal
            previewUrl={
              this.state.previewUrl
            }
            closeModal={this.closeModal}
          />
        </Modal> */}
      </div>
    );
  }
}

PadiScuba.propTypes = {
  pADIMedicalFormPage1: PropTypes.shape({}).isRequired,
  pADIMedicalFormPage2: PropTypes.shape({}).isRequired,
  scubaLiabilityRelease: PropTypes.shape({}).isRequired,
  destination: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired,
  setDocumentsAccordionState: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default PadiScuba;
